import { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Col, Container, Form, FormGroup, Input,Row } from 'reactstrap';
import LoginImage from '@assets/images/logo/login.svg';
import Tab from '@components/atom/Tab';
import { swalMessage } from '@components/common';
import { postMerchantLogin, postUserLogin } from '@lib/api/v2/auth';
import useHandleAPICall from '@lib/hooks/useHandleAPICall';
import useAppStore from '@store/useAppStore';
import { swalReturnWarning } from '@util/commonFunctions';
import LOG_PREFIX from '@util/logger/constants';
import { createLogger } from '@util/logger/logger';
import Swal from 'sweetalert2';

const logger = createLogger(LOG_PREFIX.AUTH);

const Logins = () => {
  const { setUserPhoneNumber } = useAppStore();
  const { createRequest } = useHandleAPICall();
  const [LoginData, setLoginData] = useState({ id: '', password: '' });
  const [selectedTab, setSelectedTab] = useState('admin');
  const [togglePassword, setTogglePassword] = useState(false);
  const { id, password } = LoginData;
  const handleOnChange = (e) => {
    setLoginData({ ...LoginData, [e.target.name]: e.target.value });
  };

  const handleLogin = async () => {
    try {
      let res;
      if (selectedTab === 'admin') res = await createRequest(postMerchantLogin, id, password);
      if (selectedTab === 'user') res = await createRequest(postUserLogin, id, password);

      if (res.status === 200) {
        const { data } = res;
        logger.info('로그인 성공', { userType: selectedTab });
        if (selectedTab === 'user') setUserPhoneNumber(data?.phoneNum || '');
      } else if (res.status === 202 && res.data === 102) {
        logger.warn('로그인 실패 - 아이디 오류', { userType: selectedTab });
        Swal.fire({
          text: '아이디가 잘못됐습니다. 다시 입력해주세요.',
          confirmButtonColor: '#04c9db',
        });
      } else if (res.status === 202 && res.data === 101) {
        logger.warn('로그인 실패 - 비밀번호 오류', { userType: selectedTab });
        Swal.fire({
          text: '비밀번호가 잘못됐습니다. 다시 입력해주세요.',
          confirmButtonColor: '#04c9db',
        });
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Unknown error';
      logger.error('로그인 에러', {
        userType: selectedTab,
        error: errorMessage,
      });
      if (errorMessage.includes('401') || errorMessage.includes('500'))
        return swalReturnWarning(
          `아이디 또는 비밀번호를 잘못 입력했습니다.\n\n키오스크에서 회원가입하신 경우 비밀번호를 재설정해 주세요.`,
        );
      swalMessage('error', '에러가 발생했습니다.\n잠시 후 다시 시도해 주세요.', '확인', false);
    }
  };

  const onClickjoin = () => {
    window.location.href = `${process.env.PUBLIC_URL}/auth/join`;
  };

  const onClickPassword = () => {
    window.location.href = `${process.env.PUBLIC_URL}/auth/password`;
  };

  const handleKeyup = () => {
    if (window.event.keyCode === 13) {
      handleLogin();
    }
  };
  return (
    <Container style={{ overflow: 'hidden' }} fluid={true} className="p-0">
      {/* {window.innerWidth > 480 && <AuthHeader />} */}
      <Row>
        <Col xs="12">
          <div className="login-card">
            <div className={window.innerWidth < 1080 ? 'card-style' : 'card-style'}>
              <div style={{ marginBottom: '40px' }}>
                <img className="img-fluid for-light" src={LoginImage} alt="" />
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  width: '100%',
                }}
                className="login-main login-tab">
                <Form className="theme-form">
                  <Tab
                    selected={selectedTab}
                    setSelected={setSelectedTab}
                    tabItems={[
                      { key: 'admin', text: '관리자' },
                      { key: 'user', text: '사용자' },
                    ]}
                  />
                  <div style={{ height: '1rem' }} />
                  <FormGroup>
                    <Input
                      className="form-control"
                      placeholder="휴대폰 번호를 적어주세요."
                      type="text"
                      name="id"
                      required
                      value={id}
                      onChange={handleOnChange}
                    />
                  </FormGroup>
                  <FormGroup style={{ position: 'relative' }}>
                    <div className="show-hide" onClick={() => setTogglePassword(!togglePassword)}>
                      <span className={togglePassword ? '' : 'show'}></span>
                    </div>
                    <Input
                      className="form-control"
                      placeholder="비밀번호를 적어주세요."
                      type={togglePassword ? 'text' : 'password'}
                      name="password"
                      onChange={handleOnChange}
                      onKeyUp={() => handleKeyup()}
                      required
                    />
                  </FormGroup>
                  <a className="ml-2" href="#javascript" onClick={() => onClickPassword()}>
                    비밀번호 찾기
                  </a>
                </Form>
                <button className="loginBtn" onClick={() => handleLogin()}>
                  로그인
                </button>
                <p className="text">
                  아직 렛미업 회원이 아니신가요?
                  <br />
                </p>
                <button className="loginBtn line" onClick={() => onClickjoin()}>
                  회원가입
                </button>
                {/* <p className="mt-4 mb-0">
                  비밀번호를 모르실 경우
                  <br />
                  <a
                    className="ml-2"
                    href="#javascript"
                    onClick={() => onClickPassword()}
                  >
                    여기
                  </a>
                  를 클릭해주세요
                </p> */}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default withRouter(Logins);
